import * as React from 'react'

import {
  GlobalHelpCentreAccordionCollection,
  GlobalHelpCentreCollection,
  GlobalHelpCentreAccordion,
  GlobalHelpCentreAccordion2,
} from '@thg-commerce/enterprise-network/src/generated/graphql'
import {
  HelpCentreCollection,
  HelpCentreCollectionProps,
} from '@thg-commerce/enterprise-widget-help-centre-collection'
import {
  AccordionContainerProps,
  HorizontalAlignment,
} from '@thg-commerce/enterprise-widget-accordion-container'
import { mq, spacing, styled } from '@thg-commerce/gravity-theme'

import { BaseWidgetProps } from '../types'

interface HelpCentreAccordionCollection
  extends Omit<
    GlobalHelpCentreAccordionCollection,
    'id' | 'query' | 'banners'
  > {
  banners:
    | Omit<GlobalHelpCentreAccordion, 'id' | 'query'>[]
    | Omit<GlobalHelpCentreAccordion2, 'id' | 'query'>[]
}

interface HelpCentreCollectionWithChildren
  extends Omit<GlobalHelpCentreCollection, 'id' | 'query' | 'banners'> {
  banners: HelpCentreAccordionCollection[]
}

export type HelpCentreCollectionWidgetRendererProps = BaseWidgetProps &
  Omit<HelpCentreCollectionWithChildren, 'query'>

const StyledContainer = styled.div`
  background: ${(props) => props.theme.colors.palette.greys.lighter};
`

const StyledHelpCentreCollection = styled(HelpCentreCollection)`
  padding: ${spacing(3)} 0 ${spacing(1)};
  margin: 0 auto;
  max-width: ${(props) => props.theme.site.siteWidth};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(4)} ${spacing(4)} ${spacing(10)};
  }
`

export const HelpCentreCollectionWidgetRenderer = (
  props: HelpCentreCollectionWidgetRendererProps,
) => {
  if (props?.banners?.length === 0) {
    return null
  }

  const helpCentreCollectionWidgetProps: HelpCentreCollectionProps = {
    accordions: props.banners.reduce<HelpCentreCollectionProps['accordions']>(
      (accumulator, accordion) => {
        if ((accordion.banners || []).length === 0) {
          return accumulator
        }
        accumulator.push({
          title: accordion.title || '',
          items: accordion.banners.map((accordionItem) => {
            return {
              title: accordionItem.accordionHeading,
              content: accordionItem.accordionContent?.content[0]?.content,
              isOpen: false,
            }
          }),
          alignment: HorizontalAlignment.LEFT,
        })
        return accumulator
      },
      [],
    ),
  }

  return (
    <StyledContainer>
      <StyledHelpCentreCollection {...helpCentreCollectionWidgetProps} />
    </StyledContainer>
  )
}
